import { isEmpty, isNumber, isString } from 'lodash';

export type Grade = number | string;

export interface UserGrade {
  userId: string;
  grade: Grade;
}

export namespace Grade {
  export function isGrade(grade: any): grade is Grade {
    return (isString(grade) && !isEmpty(grade)) || isNumber(grade);
  }
}
